// @ts-nocheck
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import React from 'react';
import { TABS } from '../data/initialData';
import { getTabIcon } from './tab-icons';
import './Sidebar.css';

export default function Sidebar({
  activeTab,
  onTabChange,
  onPreview,
  onDownloadPDF,
  onSaveResume,
  onGenerateAtsScore,
  isPreview,
  isExporting,
  isSaving,
  isEditingResume,
}) {
  return (
    <aside className="sidebar topbar">
      <nav className="sidebar-nav" role="tablist" aria-label="Resume sections">
        {TABS.map((tab, idx) => (
          <button
            key={tab.id}
            role="tab"
            aria-selected={activeTab === tab.id && !isPreview}
            className={`nav-item ${activeTab === tab.id && !isPreview ? 'active' : ''}`}
            onClick={() => onTabChange(tab.id)}
            title={tab.label}
          >
            <span className="nav-icon" aria-hidden="true">{getTabIcon(tab.id)}</span>
            <span className="nav-text">{tab.label}</span>
          </button>
        ))}

        <div className="sidebar-actions">
          {/* Preview / Edit toggle */}
          <button
            className={`action-btn ${isPreview ? 'action-btn--edit' : 'action-btn--preview'}`}
            onClick={onPreview}
            title={isPreview ? 'Back to editing' : 'Preview your resume'}
          >
            {isPreview
              ? <EditOutlinedIcon fontSize="inherit" />
              : <VisibilityOutlinedIcon fontSize="inherit" />
            }
            {isPreview ? 'Edit' : 'Preview'}
          </button>

          {/* ATS Score */}
          {/* <button
            className="action-btn action-btn--ats"
            onClick={onGenerateAtsScore}
            title="Check ATS compatibility score"
          >
            <FactCheckOutlinedIcon fontSize="inherit" />
            ATS Score
          </button> */}

          {/* Download PDF */}
          <button
            className="action-btn action-btn--print"
            onClick={onDownloadPDF}
            disabled={isExporting}
            title="Download as PDF"
          >
            {!isExporting && <PictureAsPdfOutlinedIcon fontSize="inherit" />}
            {isExporting ? 'Preparing…' : 'Download PDF'}
          </button>

          {/* Save */}
          <button
            className="action-btn action-btn--save"
            onClick={onSaveResume}
            disabled={isSaving}
            title={isEditingResume ? 'Update saved resume' : 'Save resume'}
          >
            {!isSaving && <SaveOutlinedIcon fontSize="inherit" />}
            {isSaving
              ? (isEditingResume ? 'Updating…' : 'Saving…')
              : (isEditingResume ? 'Update' : 'Save')
            }
          </button>
        </div>
      </nav>
    </aside>
  );
}
